module.exports = __webpack_public_path__ + "img/frame.31177f58.svg";